import { hideAndRemove } from "../../helpers";
import { toggleSceneObject } from "../../togglers";

export const changePerfopanelVerstak = (value, isChecked, preservedY = null) => {
    const isFullWidth = value !== "left" && value !== "right";

    const verstakName = servObj.tempName;

    const width = isFullWidth ? servObj.tableSize.tableWidth.current : servObj.tableSize.tableWidth.current / 2;
    const name = isFullWidth
        ? `verstak__${verstakName}__perfopanel__${width}x${value}`
        : `perfopanel__${value}__${width}x325`;

    let yPos = 10;
    if (!isFullWidth) yPos = 11.15;

    if (isFullWidth) {
        toggleSceneObject({
            allObjects: servObj.allPerfopanel,
            activeArray: servObj.activePerfopanel,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (
                    el.name.includes(`perfopanel__${width}x`) &&
                    !el.name.includes("left") &&
                    !el.name.includes("right")
                ) {
                    hideAndRemove(el); // Удаляем объект со сцены
                    return false; // Исключаем из массива
                }
                return true;
            },
            position: {
                y: preservedY ?? yPos,
            },
            userData: { name, type: value, value, verticalOnly: true },
            hideChildrenName: ["hitbox"],
            excludes: ["ostrov"],
        });
    } else {
        toggleSceneObject({
            allObjects: servObj.allPerfopanel,
            activeArray: servObj.activePerfopanel,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (el.userData.value === value) {
                    hideAndRemove(el); // Удаляем объект со сцены
                    return false; // Исключаем из массива
                }
                return true;
            },
            position: { y: preservedY ?? yPos },
            userData: { name, type: value, value, width, verticalOnly: true },
            hideChildrenName: ["hitbox"],
        });
    }
};
